module.exports = __webpack_public_path__ + "static/media/logo-sm.168a7277.svg";